var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import ptBR from 'date-fns/locale/pt-BR'; // Importando a localização em pt-BR
import React, { useState } from 'react';
import { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'; // Certifique-se de ter o CSS do react-datepicker importado
import { useSelector } from 'react-redux';
import { CalendarIcon, Container, CurrencyInputField, DateContainer, DateSelect, FieldLabel, Input, MaskedInput, Select } from './styles';
registerLocale('pt-BR', ptBR); // Registrando a localização
var FieldText = function (_a) {
    var field = _a.field, onChangeText = _a.onChangeText, onBlur = _a.onBlur;
    var theme = useSelector(function (state) { return state.theme; }).theme;
    var _b = useState(null), selectedOption = _b[0], setSelectedOption = _b[1];
    var renderInputComponent = function () {
        if (field.options && field.options.length) {
            return (React.createElement(Select, { isDisabled: field.enabled === false, id: field.label, name: field.label, value: selectedOption || field.value ? { label: field.value, value: field.value } : null, onChange: function (newValue) {
                    setSelectedOption(newValue);
                    onChangeText(newValue.value);
                }, options: field.options.map(function (option) { return ({ label: option, value: option }); }), styles: {
                    control: function (base) { return (__assign(__assign({}, base), { border: 'none', boxShadow: 'none', backgroundColor: 'transparent' })); },
                    singleValue: function (base) { return (__assign(__assign({}, base), { color: theme.inputTextColor })); },
                    input: function (base) { return (__assign(__assign({}, base), { color: theme.inputTextColor })); },
                    menuList: function (base) { return (__assign(__assign({}, base), { backgroundColor: theme.inputBackgroundColor })); },
                    placeholder: function (base) { return (__assign(__assign({}, base), { color: theme.inputPlaceholderColor })); }
                }, onBlur: onBlur }));
        }
        ;
        if (field.type === 'DATE') {
            if (field.maskRegex && (field.maskRegex.includes("dd") || field.maskRegex.includes("YY"))) {
                return (React.createElement(DateContainer, null,
                    React.createElement(DateSelect, { disabled: field.enabled === false, showYearDropdown: true, showMonthDropdown: true, selected: typeof field.value === 'string'
                            ? new Date(Number.parseInt(field.value.split('-')[0]), Number.parseInt(field.value.split('-')[1]) - 1, Number.parseInt(field.value.split('-')[2]))
                            : field.value, dateFormat: field.maskRegex, onChange: function (date) { return onChangeText(date); }, placeholderText: field.placeholder, maxDate: new Date(new Date().setFullYear(new Date().getFullYear() - 18)), locale: "pt-BR" // Aqui você define o idioma como pt-BR
                        , onChangeRaw: function (event) {
                            if (event.target.value) {
                                var value = event.target.value.replace(/\D/g, ''); // Remove non-digits
                                var formattedValue = value.replace(/^(\d{0,2})(\d{0,2})(\d{0,4}).*/, function (_match, p1, p2, p3) {
                                    var result = '';
                                    if (p1)
                                        result += p1;
                                    if (p2)
                                        result += '/' + p2;
                                    if (p3)
                                        result += '/' + p3;
                                    return result;
                                });
                                event.target.value = formattedValue;
                            }
                        }, onBlur: onBlur })));
            }
            else {
                return (React.createElement(DateContainer, null,
                    React.createElement(DateSelect, { disabled: field.enabled === false, showYearDropdown: true, showMonthDropdown: true, selected: typeof field.value === 'string'
                            ? new Date(Number.parseInt(field.value.split('-')[0]), Number.parseInt(field.value.split('-')[1]) - 1, Number.parseInt(field.value.split('-')[2]))
                            : field.value, onChange: function (date) { return onChangeText(date); }, placeholderText: field.placeholder, maxDate: new Date(new Date().setFullYear(new Date().getFullYear() - 18)), locale: "pt-BR" // Aqui você define o idioma como pt-BR
                        , onChangeRaw: function (event) {
                            if (event.target.value) {
                                var value = event.target.value.replace(/\D/g, ''); // Remove non-digits
                                var formattedValue = value.replace(/^(\d{0,2})(\d{0,2})(\d{0,4}).*/, function (_match, p1, p2, p3) {
                                    var result = '';
                                    if (p1)
                                        result += p1;
                                    if (p2)
                                        result += '/' + p2;
                                    if (p3)
                                        result += '/' + p3;
                                    return result;
                                });
                                event.target.value = formattedValue;
                            }
                        }, onBlur: onBlur }),
                    React.createElement(CalendarIcon, { color: theme.primaryColor })));
            }
        }
        if (field.type === 'MONEY') {
            return (React.createElement(CurrencyInputField, { disabled: field.enabled === false, prefix: "R$", decimalsLimit: 2, groupSeparator: ".", decimalSeparator: ",", allowNegativeValue: false, placeholder: field.placeholder, intlConfig: { locale: 'pt-BR', currency: 'BRL' }, onValueChange: function (value) { return onChangeText(value || ""); } }));
        }
        if (field.maskRegex) {
            return (React.createElement(MaskedInput, { disabled: field.enabled === false, value: field.value || "", mask: field.maskRegex, maskChar: null, formatChars: { '0': '[0-9]', '9': '[0-9]' }, alwaysShowMask: false, placeholder: field.placeholder, onChange: function (e) { return onChangeText(e.target.value); }, onBlur: onBlur }));
        }
        return (React.createElement(Input, { disabled: field.enabled === false, type: field.type === "PASSWORD" ? "password" : "text", value: field.value || "", maxLength: field.maxSize, placeholder: field.placeholder, readOnly: field.type === 'SELECT', onChange: function (e) { return onChangeText(e.target.value); }, onBlur: onBlur }));
    };
    return (React.createElement(Container, null,
        React.createElement(FieldLabel, null,
            field.label,
            " ",
            field.required && React.createElement("span", null, "*")),
        renderInputComponent()));
};
export default FieldText;
